import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'siret',
  standalone: false,
})
export class SiretPipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      const regx: RegExp = /^(\d{3})(\d{3})(\d{3})(\d{5})$/g;
      const regxSpace: RegExp = /\s/g;
      value = value.replace(regxSpace, '');

      if (regx.test(value)) {
        return value.replace(regx, '$1 $2 $3 $4');
      }
    }
    return '';
  }
}
